import styles from "./Checkbox.module.scss";

type Props = {
  id?: unknown;
  checked?: boolean;
  disabled?: boolean;
  onClick?: (id: unknown) => void; 
};

export const Checkbox: React.FC<Props> = ({id, checked = false, disabled = false, onClick = () => {}}) => {
  const handleClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    e.stopPropagation();
    onClick(id);
  };

  return (
    <div
      onClick={handleClick}
      className={`${styles['checkbox']} ${checked ? styles['checked'] : ''} ${disabled ? styles['disabled'] : ''}`}
    />
  );
};
